import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Probleme" className="border-y border-grape/10 bg-white/70" data-id="element-115" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-116" data-mp="26xmt34jwpsfl">
        <h2 className="text-center font-display text-[25px] font-black text-grape sm:text-4xl" data-id="element-117" data-mp="2bvy4hjpuoazx">
          Erkennen Sie sich hier wieder?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-118" data-mp="21z37j5986inr">
          Sie arbeiten mit verletzten Athleten und wollen ihnen helfen, richtig zu genesen. Aber
          jedes Mal, wenn Sie ein Protokoll erstellen wollen, verlieren Sie sich zwischen
          Übungsauswahl, Progressionskriterien und Return-to-Sport-Zeitplänen, die ins Leere führen.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-119" data-mp="3ncfmwfwm4d3k">
          Es mangelt nicht an Talent. Es mangelt nicht an Einsatz. Es mangelt an einem visuellen
          System.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-120" data-mp="1u2di0ebz7ex0">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-121" data-mp="27sqpkfkygrlt" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-122" data-mp="1p3ab0ocfqyme">
                {p.emoji}
              </span>
              <div data-id="element-123" data-mp="30gmgt4rr9rb7">
                <h3 className="text-sm font-bold text-plum" data-id="element-124" data-mp="30ft9a1kz2xs0">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-125" data-mp="2vhjf9uazi37z">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-126" data-mp="1t79fstyh82yc">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-127" data-mp="1y3gjeg3eh2d4">
            ✨ Wenn Sie bei einer dieser Fragen mit JA geantwortet haben, haben wir die Lösung.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-128" data-mp="275g1lbq5ichn">
            Tag 30 kann sich komplett anders anfühlen.
          </p>
        </div>
      </div>
    </section>;
}